import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { Role } from '../shared/role';
import { RoleService } from '../shared/role.service';

import {ConfirmationService} from 'primeng/primeng';

@Component({

    selector: 'role-crud',
    templateUrl: './role-crud.component.html',
    styleUrls: ['./role-crud.component.scss']
})
export class RoleCrudComponent implements OnInit, OnDestroy {
    @Input() role: Role;
    @Input() id: number;
    @Input() operation: string;
    
  
  
    fromRoute: boolean;

    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;


    constructor(public rootService: RootService,
        public roleService: RoleService,
        public route: ActivatedRoute,
        public router: Router,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {

        var routeData = this.route.snapshot.data;
        if( routeData['page'] && ((routeData['page']).split("."))[1] == "role"){
            this.fromRoute = routeData['fromRoute'];
            this.operation = routeData['operation'];
        }


    }
    ngOnChanges() {

    }
    update() {
        this.operation ='update';
    }
    back(){
        this.router.navigate(['admin/role']);
    }
    
    ngOnInit() {
        if (this.fromRoute) {
            if (this.operation == 'create') {
                this.id=null;
            } else {
                this.routeEvent = this.router.events.subscribe((val) => {
                    if (val instanceof NavigationEnd) {
                        this.route.params.subscribe(params => {
                            this.id = +params['id']; // (+) converts string 'id' to a number
                        });
                    }
                });
            }
        }

    }
    ngOnDestroy() {

    }
}



// WEBPACK FOOTER //
// ./src/app/module/role/role-crud/role-crud.component.ts